export default {
  tookRfQuiz: {},
  tookMmQuiz: {},
  tookLmQuiz: {},
};
